/* eslint-disable no-undef */
import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isCareplus } from '~/utils/constants/isCareplus';

export const MainContext = createContext();

export default function MainContextProvider({ children }) {
  const [buttonDisplay, setButtonDisplay] = useState(false);
  const [goBackNewConsult, setGoBackNewConsult] = useState(true);
  const [showHome, setShowHome] = useState(true);
  const [validated, setValidated] = useState(false);
  const [dataDocument, setDataDocument] = useState(null);
  const [plataformValidation, setPlataformValidation] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const [loginDisplay, setLoginDisplay] = useState(false);
  const [alertControlled, setAlertControlled] = useState(false);
  const [isAlertMessageOpen, setAlertMessageOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [captchaValidation, setcaptchaValidation] = useState(false);
  const [redirectTo, setRedirectTo] = useState('');

  useEffect(() => {
    if (isCareplus && document) {
      document.title = 'Verifica Care Plus';
    }
  }, []);

  return (
    <MainContext.Provider
      value={{
        buttonDisplay,
        setButtonDisplay,
        goBackNewConsult,
        setGoBackNewConsult,
        showHome,
        setShowHome,
        validated,
        setValidated,
        dataDocument,
        setDataDocument,
        plataformValidation,
        setPlataformValidation,
        inputValue,
        setInputValue,
        loginDisplay,
        setLoginDisplay,
        alertControlled,
        setAlertControlled,
        isAlertMessageOpen,
        setAlertMessageOpen,
        setAlertMessage,
        alertMessage,
        captchaValidation,
        setcaptchaValidation,
        redirectTo,
        setRedirectTo,
      }}
    >
      {children}
    </MainContext.Provider>
  );
}

MainContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};
